import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { EmployeeHomeAddressState, employeeHomeAddressFeatureKey } from '../reducers/employee-home-address.reducer';
import * as employeeHomeAddressState from '../reducers/employee-home-address.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, EmployeeHomeAddressState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getEmployeeHomeAddressState = createSelector(getMainEmployeeState, state => state[employeeHomeAddressFeatureKey]);
//#endregion

export const getEmployeeHomeAddressSuccess = createSelector(
    getEmployeeHomeAddressState,
  employeeHomeAddressState.getEmployeeHomeAddressResponse
);
export const getEmployeeHomeAddressFailure = createSelector(
  getEmployeeHomeAddressState,
  employeeHomeAddressState.getEmployeeHomeAddressFailure
);
//#endregion
